import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1173_56570)">
        <rect width={36} height={24} fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7046 2.31064C17.8932 2.22979 18.1068 2.22979 18.2954 2.31064L25.2954 5.31064C25.6762 5.47381 25.8525 5.91472 25.6894 6.29544C25.5262 6.67616 25.0853 6.85253 24.7046 6.68936L18 3.81598L11.2954 6.68936C10.9147 6.85253 10.4738 6.67616 10.3106 6.29544C10.1475 5.91472 10.3238 5.47381 10.7046 5.31064L17.7046 2.31064ZM8.25 10C8.25 9.58579 8.58579 9.25 9 9.25H27C27.4142 9.25 27.75 9.58579 27.75 10C27.75 10.4142 27.4142 10.75 27 10.75H26.75V20.25H27C27.4142 20.25 27.75 20.5858 27.75 21C27.75 21.4142 27.4142 21.75 27 21.75H9C8.58579 21.75 8.25 21.4142 8.25 21C8.25 20.5858 8.58579 20.25 9 20.25H9.25V10.75H9C8.58579 10.75 8.25 10.4142 8.25 10ZM10.75 10.75V20.25H25.25V10.75H10.75ZM14 13.25C14.4142 13.25 14.75 13.5858 14.75 14V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17V14C13.25 13.5858 13.5858 13.25 14 13.25ZM18 13.25C18.4142 13.25 18.75 13.5858 18.75 14V17C18.75 17.4142 18.4142 17.75 18 17.75C17.5858 17.75 17.25 17.4142 17.25 17V14C17.25 13.5858 17.5858 13.25 18 13.25ZM22 13.25C22.4142 13.25 22.75 13.5858 22.75 14V17C22.75 17.4142 22.4142 17.75 22 17.75C21.5858 17.75 21.25 17.4142 21.25 17V14C21.25 13.5858 21.5858 13.25 22 13.25Z"
          fill="#1E293B"
        />
      </g>
      <rect x={0.5} y={0.5} width={35} height={23} stroke="#E2E8F0" />
      <defs>
        <clipPath id="clip0_1173_56570">
          <rect width={36} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-pay-by-bank" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
